<!--  ############### Top Select Month Start ################# -->
<!-- <div class="select_month_section">
	<section class="row">
		<div class="select_month col-auto">
			<h2><i class="bi bi-filter"></i><label for="select_year_month">Select Date</label> </h2>
			<select class="form-select year" aria-label="Default select example" (change)="fncCng($event, 'year')" [(ngModel)] = "selectedYear">
				<option *ngFor="let year of yearDropdown" [value]="year">
					{{year}}
				</option>
			</select>
			<select class="form-select month" aria-label="Default select example" (change)="fncCng($event, 'month')"  [(ngModel)]="selectedMonth">
				<option *ngFor="let num of monthList" value="{{num}}">{{num}}</option>
			</select>
			
		</div>
		<div class="col-auto co_name">
			<h2>{{"CompanyName" | translate}}:</h2>
			<p>{{userName}}</p>
		</div>
	</section>
</div> -->
<!--  ############### Top Select Month End ################# -->
<!--  ############### Middle Containt Area Start ################# -->
<div class="container_wrapper">
	<div class="filter_options">
		<div class="row align-items-center">
			<div><h3>{{"Management.Filters" | translate}}</h3></div>
			<div class="float_end"><span class="result_count">{{"Management.ResultCnt" | translate}}: {{totalCount}}</span></div>
		</div>
		
		<div class="row align-items-end">
			<!-- <div class="mb-3">
				<label class="col-form-label">{{"SelectSupplier" | translate}}</label>
				<select class="form-select" id="" name="" [(ngModel)]="selectedSupplierId">
					<option value="-1">{{"All" | translate}}</option>
					<option value="1">{{"SupplierName" | translate}}</option>
				</select>
			</div> -->
            <div class="mb-3">
				<label class="col-form-label">{{"Supplierbranch" | translate}}:</label>
				<select 
                class="form-select" 
                [(ngModel)]="selectedBranch"
                aria-label="Month selection">
                    <option value="-1"> {{"All" | translate}}</option>
                    <option *ngFor="let branch of branchDropdown" [value]="branch.branchId">
                        {{branch.branchName}}
                    </option>
                </select>
			</div>
            <div class="mb-3">
				<label class="col-form-label">{{"Company" | translate}}:</label>
				<select 
                class="form-select" 
                [(ngModel)]="selectedCustomer"
                aria-label="Month selection">
                    <option value="-1"> {{"All" | translate}}</option>
                    <option *ngFor="let customer of customerDropdown" [value]="customer.customerID">
                        {{customer.customerName}}
                    </option>
                </select>
			</div>
            <div class="mb-3">
				<label class="col-form-label">{{"SelectDate" | translate}}</label>
				<select class="form-select year" aria-label="Default select example" [(ngModel)] = "selectedYear">
                    <option *ngFor="let year of yearDropdown" [value]="year">
                        {{year}}
                    </option>
                </select>                
			</div>
            <div class="mb-3">
                <select class="form-select month" aria-label="Default select example" [(ngModel)]="selectedMonth" style="width: 70px;">
                    <option *ngFor="let num of monthList" value="{{num}}">{{num}}</option>
                </select>
            </div>
            
            
			
			<div class="mb-3">
				<button type="button" class="btn btn-primary" (click)="searchContracts()">{{"Management.Search" | translate}}</button>
				<button type="button" class="btn btn-primary" (click)="clearAll()">{{"Management.ClearAll" | translate}}</button>
			</div>
		</div>
	</div>

	<div class="actio_button_area">
		<!-- <span class="result_count">{{"Management.ResultCnt" | translate}}: {{totalCount}}</span> -->
		<!-- <button class="butn download_entry btn">{{"Home.Download" | translate}}</button> -->
		<!--<button class="butn cancel_entry btn">{{"CANCEL" | translate}}</button>-->
	</div>
	<div *ngIf="dashboard_msg !== null" class="alert alert-{{msgType}} alert-dismissible" (click)="reset()" role="alert">
            {{ dashboard_msg | translate}}
			  
		<button type="button" class="close" data-dismiss="alert" aria-label="Close" style="float: right; border-radius: 15px; border: none;">
			<span aria-hidden="true">&times;</span>
			</button>
	</div>
	<!--  ############### Data Table Start ################# -->
	<div class="client_associate_list">
		<p-table 
        #dt2
        [value]="contractList" [tableStyle]="{'width':'100%'}" 
        [paginator]="true"
        [rows]="10"
        [showCurrentPageReport]="true"
        [globalFilterFields]="['supplier', 'customer', 'sectionName', 'userName']"
        currentPageReportTemplate="{{'Showing' |translate}} {first} {{'to' | translate}} {last} {{'of' | translate}} {totalRecords} {{'entries' | translate}}"
        (onFilter)="onFilter($event)"
        (onPage)="onPage($event)">
        <!-- (onSort)="onSort()" -->
        <!-- <table class="display nowrap table table-striped" style="width:100%"> -->
            <ng-template #caption>
                
                    <p-iconfield iconPosition="left" class="ml-auto">                        
                        <label>{{"SearchByText" | translate}}:</label>
                        <input pInputText type="text" (input)="onGlobalFilter($event)" placeholder="{{'SearchKey' | translate}}" />
                    </p-iconfield>
                
            </ng-template>
            <ng-template pTemplate="header">                
				<tr class="tbl_head">
					<th class="bor_lft_none">{{"Notification.Supplier" | translate}}</th>
					<th>{{"Notification.Company" | translate}}</th>
					<th>{{"Notification.Section" | translate}}</th>
					<th>{{"Notification.ContractNo" | translate}}</th>
					<th>{{"Notification.OrderNo" | translate}}</th>
					<th>{{"Notification.Name" | translate}}</th>
				</tr>
                <!-- </thead>     -->
            </ng-template>
            <!-- <ng-template pTemplate="body" let-item>
                <tr class="tbl_cont">
                	<td class="bor_lft_none">{{item.supplier}}</td>
                    <td>{{item.customer}}</td>
                    <td>{{item.sectionName}}</td>
                    <td>{{item.contractNo}}</td>
                    <td>{{item.jobOrderIdOrg}}</td>
                    <td><a href="contract-details/{{item.jobOrderID}}">{{item.userName}}</a></td>
                </tr>
            </ng-template> -->
			<ng-template pTemplate="body" let-supplier>    
				<ng-container *ngFor="let section of supplier.sectionDto; let s_i = index">				
					<ng-container *ngFor="let job of section.jobOrderDtos; let j_i = index">
						<tr class="tbl_cont">

						<!-- Supplier cell -->
						<td *ngIf="s_i === 0 && j_i === 0"
							[attr.rowspan]="getSupplierRowspan(supplier)">
							{{ supplier.supplier }}
						</td>
						<td *ngIf="s_i === 0 && j_i === 0"
							[attr.rowspan]="getSupplierRowspan(supplier)">
							{{ supplier.customer }}
						</td>

						<!-- Section cell -->
						<td *ngIf="j_i === 0"
							[attr.rowspan]="getSectionRowspan(section)">
								{{ section.sectionName }}
						</td>

						<!-- Job Order -->
						<td>
							{{ job.contractNo }}
						</td>

						<!-- User hyperlink -->
						<td>
							{{job.jobOrderIdOrg}}
						</td>

						<!-- Contract term -->
						<td>
							<a href="contract-details/{{job.jobOrderID}}">
							{{ job.userName }}
							</a>
						</td>

						</tr>
					</ng-container>
				</ng-container>
			</ng-template>    
            
        </p-table>
		
	</div>

	<!--  ############### Data Table End ################# -->

</div>
<!--  ############### Middle Containt Area End ################# -->
